<template>

  <div class="">
    <el-date-picker
      v-model="dateRange.from"
      type="datetime"
      placeholder="开始时间"
      :picker-options="pickerOptions"
      value-format="timestamp"
      default-time="00:00:00"
      class="activity-edit-date el_box"
    >
    </el-date-picker>
    <span class="to">至</span>
    <el-date-picker
      v-model="dateRange.to"
      type="datetime"
      placeholder="终止时间"
      :picker-options="pickerOptions"
      value-format="timestamp"
      default-time="23:59:59"
      class="activity-edit-date el_box"
    >
    </el-date-picker>
  </div>



</template>

<style lang="scss" scoped>

</style>

<script>

  export default {
    props:['clear','searchInfo'],
    model: {
       event: "change"
    },
    data() {
      return {
        activeName: null,
        dateRange: {
          from: "",
          to: ""
        },
        pickerOptions: {
          disabledDate(time) {
            // 今天之后的日子都不可选择
            return time.getTime() > Date.now();
          }
        }
      };
    },
    mounted() {
      if(!this.clear){
         this.dateRange.from=new Date((new Date().setHours(0, 0, 0, 0))).getTime();
         this.dateChange();
      }
      if(!this.setEndTime){
         this.dateRange.to=new Date((new Date().setHours(23, 59, 59, 0))).getTime();
         this.dateChange();
      }
      if(this.searchInfo){
        let searchInfo=JSON.parse(this.searchInfo);
        this.dateRange.from=searchInfo.createTimeStart;
        this.dateRange.to=searchInfo.createTimeEnd;
      }
    },
    watch: {
      'dateRange.from':function(){
        this.dateChange();
      },
      'dateRange.to':function(){
        this.dateChange();
      },
    },
    methods: {
      dateChange() {
        this.$emit("dateChange", {
          from: this.dateRange.from,
          to: this.dateRange.to
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .to{
    margin: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// date-selector.vue?02295530